import React, { useState, useEffect } from "react";
import Header from "../../components/header";
import styles from "./PresupuestosConfiguracion.module.css";
import History from "../../components/history";
import { Row, Col, Button, Table } from "react-bootstrap";
import { useCookies } from 'react-cookie';
import PlanCuentasCard from "../PlanCuentas/PlanCuentasCard";
import { Icon, InlineIcon } from '@iconify/react';
import eyeFilled from '@iconify/icons-ant-design/eye-filled';
import downOutlined from '@iconify/icons-ant-design/down-outlined';
import upOutlined from '@iconify/icons-ant-design/up-outlined';
import editFilled from '@iconify/icons-ant-design/edit-filled';
import bxsTrash from '@iconify/icons-bx/bxs-trash';
import { checkSession, isMobile } from "../../core/session";
import axios from 'axios';
import PresupuestosConfiguracionEditModal from "./PresupuestosConfiguracionEditModal/PresupuestosConfiguracionEditModal";
import PresupuestosConfiguracionAddModal from "./PresupuestoConfiguracionModalAdd";

const PresupuestosConfiguracion = (props) => {

    const loadingBtn = require("../../assets/loaders/btn-loading.gif");

    const [cookie, setCookies, removeCookie] = useCookies(['kUserSession']);
    const [showModal, setShowModal] = useState(false);
    const [loading, setLoading] = useState(false);
    const [categorias, setCategorias] = useState([]);

    const [addModalVisible, setAddModalVisible] = useState(false);
    const [editModalVisible, setEditModalVisible] = useState(false);
    const [categoriaEditando, setCategoriaEditando] = useState(null);    

    const history = [
        {
            name: "Inicio",
            path: "/"
        },
        {
            name: "Presupuestos",
            path: "/presupuestos"
        }
    ]

    const prepareHeaders = () => {
        return {
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
                "Access-Control-Allow-Origin": "*",
                "api_key": "k-randa",
                "access_token": cookie.kUserSession.data.access_token
            }
        };
    }

    const abrirModalEditar = (categoria) => {
        setCategoriaEditando(categoria);
        setEditModalVisible(true);
    };    

    const getCategorias = () => {
        setLoading(true);        
        const currentFarm = cookie.kUserSession.data["farm"];
        axios.get(`${process.env.REACT_APP_API_URL}presupuestos/categorias?&estancia=${currentFarm.id}`, prepareHeaders())
        .then((response) => {
            setCategorias(response.data);
            setLoading(false);
        })
        .catch((error) => {
            console.error("Error fetching categories:", error);
            setLoading(false);
        });        
    };

    const registrarCategoria = (categoriaNueva) => {
        const payload = {
            ...categoriaNueva,
            idEstancia: { idEstancia: cookie.kUserSession.data.farm.id },
            cuentas: (categoriaNueva.cuentas || []).map(c => ({ idCuenta: c.idCuenta || c.id, codigo: c.codigo, description: c.description }))
        };
        axios.post(`${process.env.REACT_APP_API_URL}presupuestos/categorias`, payload, prepareHeaders()).
        then(() => {
            setAddModalVisible(false);
            getCategorias();
        }).
        catch((error) => {
            console.error("Error al crear categoría:", error);
        });
    };    

    const guardarCambios = () => {
        if (!categoriaEditando) return;
        const url = `${process.env.REACT_APP_API_URL}presupuestos/categorias/${categoriaEditando.idCategoriaPresupuesto}`;
        let payload = { 
            ...categoriaEditando, 
            idEstancia: { idEstancia: categoriaEditando.idEstancia },
            cuentas: (categoriaEditando.cuentas || []).map(c => ({ idCuenta: c.idCuenta || c.id, codigo: c.codigo, description: c.description }))
        }
        axios.put(url, payload, prepareHeaders()).
        then(() => {
            setEditModalVisible(false);
            getCategorias();
        }).
        catch((error) => {
            console.error("Error al actualizar categoría:", error);
        });
    };    

    useEffect(() => {
        getCategorias();
    }, []);

    return (
        <>
            <Header history={props.history} />
            <section className={styles.body}>
                <Row>
                    <Col>
                        <History items={history} current={"Configuración"} history={props.history} />
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <section className={styles.content}>
                            <Row>
                                <Col>
                                    <h1 className={styles.title}>Configuración de categorías</h1>
                                </Col>

                            </Row>
                            <section className={styles.actions}>
                                <Button className={`karanda-btn ${styles.btnRegister}`} onClick={() => setAddModalVisible(true)}>Registrar categoría</Button>
                                                            
                                {
                                    loading ? <div style={{ marginTop: "15px", textAlign: "center" }}><img src={loadingBtn} height="50" /> </div> : (

                                        categorias.length == 0 ? (
                                            <div style={{ marginTop: "15px", textAlign: "center" }}><span>No hay resultados</span></div>
                                        ) : 
                                        (
                                                isMobile() ? <span>Vista no disponible</span> : 
                                                (
                                                    <>
                                                        <Table className="karanda-table" style={{ marginTop: "15px" }}>
                                                            <thead>
                                                                <th></th>
                                                                <th>Categoría</th>
                                                                <th>Tipo</th>
                                                                <th>Fecha de creación</th>
                                                                <th>Fecha últ. modificación</th>
                                                                <th>Creado por</th>
                                                                <th>Modificado por</th>
                                                                <th>Acciones</th>
                                                            </thead>
                                                            <tbody>
                                                                {
                                                                    categorias.map((i) => (
                                                                        <>
                                                                            <tr style={{ cursor: "pointer" }} key={i.id}>
                                                                                <td onClick={() => { i.toggle = !i.toggle; setCategorias([...categorias]); }}>
                                                                                    <Icon className={styles.icon} icon={i.toggle ? upOutlined : downOutlined} height="15px" />                                                                                    
                                                                                </td>
                                                                                <td>{i.categoria}</td>
                                                                                <td>{i.tipoCategoriaPresupuesto}</td>
                                                                                <td>{new Date(i.fechaCreacion).toLocaleDateString()}</td>
                                                                                <td>{i.fechaUltModificacion ? new Date(i.fechaUltModificacion).toLocaleDateString() : "N/A"}</td>
                                                                                <td>{i.usuarioCreacion.nombres} {i.usuarioCreacion.apellidos}</td>
                                                                                <td>{i.usuarioUltModificacion ? `${i.usuarioUltModificacion.nombres} ${i.usuarioUltModificacion.apellidos}` : "N/A"}</td>
                                                                                <td>
                                                                                    <Icon className={styles.icon} icon={editFilled} height="15px" onClick={() => abrirModalEditar(i)} />
                                                                                </td>
                                                                            </tr>
                                                                            {
                                                                                i.toggle ? (
                                                                                    <tr>
                                                                                        <td colSpan={8} style={{ textAlign: "left", paddingLeft: "20px", paddingRight: "20px" }}>
                                                                                            <PlanCuentasCard accounts={i.cuentas} onlyView={true}/>
                                                                                        </td>
                                                                                    </tr>                                                                                    
                                                                                )
                                                                                : (<></>)
                                                                            }
                                                                        </>
                                                                    ))
                                                                }
                                                            </tbody>
                                                        </Table>
                                                    </>
                                                )
                                            )
                                    )
                                }

                            </section>        
                        </section>        
                    </Col>
                </Row>
                <PresupuestosConfiguracionEditModal
                    show={editModalVisible}
                    onHide={() => setEditModalVisible(false)}
                    categoria={categoriaEditando}
                    setCategoria={setCategoriaEditando}
                    onSave={guardarCambios}
                />
                <PresupuestosConfiguracionAddModal
                    show={addModalVisible}
                    onHide={() => setAddModalVisible(false)}
                    onSave={registrarCategoria}
                />

            </section>
        </>
    );

};

export default PresupuestosConfiguracion;